if (!customElements.get('product-brand')) {
  customElements.define(
    'product-brand',
    class ProductBrand extends HTMLElement {
      connectedCallback() {
        const brands = JSON.parse(
          this.querySelector('script[type="application/json"]').textContent,
        );
        const value = this.querySelector('[data-brand-value]');

        this.unsubscribe = window.subscribe(theme.PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.dataset.section) return;

          const brand = brands[String(data.variant?.id)] || '';
          value.textContent = brand;
          this.hidden = brand === '';
        });
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }
    },
  );
}
